import { IconName } from '@act/storybook';
import { Permission } from '@act/shared/authorization';
import { actingUserAppSelectors } from 'redux/slices/actingUserSlice';
import { useAppNavigation } from '../routing/useAppNavigation';
import { getCallFullScreenSaveAndClose } from '../../member-page/Calls/FullScreenSaveClose.utils';

export interface CarePortalPage {
  label: string;
  key: string;
  icon: IconName;
  postIcon?: IconName;
  onClick: () => void;
}

export const useCarePortalPages = (): CarePortalPage[] => {
  const navigate = useAppNavigation();
  const canSeeHospitalizations = actingUserAppSelectors.useUserHasPermission(
    Permission.CAN_SEE_HOSPITALIZATIONS
  );
  const showHospitalizations =
    actingUserAppSelectors.useSelectActingUser()?.showHospitalizations;

  const handleNavigation = async (navigationFn: () => void) => {
    const saveAndClose = getCallFullScreenSaveAndClose();
    if (saveAndClose) {
      await saveAndClose();
      navigationFn();
    } else {
      navigationFn();
    }
  };

  const pages: CarePortalPage[] = [
    {
      label: 'Docket',
      key: 'docket',
      icon: 'HouseLine',
      onClick: async () => {
        await handleNavigation(() => navigate.toDocket());
      },
    },
    {
      label: 'Members',
      key: 'member-list',
      icon: 'Users',
      onClick: async () => {
        await handleNavigation(() => navigate.toMemberList());
      },
    },
    {
      label: 'Calls and texts',
      key: 'calls',
      icon: 'Phone',
      onClick: async () => {
        await handleNavigation(() => navigate.toCalls());
      },
    },
  ];

  if (canSeeHospitalizations && showHospitalizations) {
    pages.push({
      label: 'Hospitalizations',
      key: 'hospitalizations',
      icon: 'Hospital',
      onClick: async () => {
        await handleNavigation(() => navigate.toHospitalizations());
      },
    });
  }

  pages.push({
    label: 'Sigma',
    key: 'dashboard',
    icon: 'Layout',
    postIcon: 'ArrowSquareOut',
    onClick: async () => {
      const saveAndClose = getCallFullScreenSaveAndClose();
      if (saveAndClose) {
        await saveAndClose();
      }
      window.open(
        'https://app.sigmacomputing.com/reema-health/workbook/Guide-Dashboard-1u9Pej2H0p7beydahA4vId',
        '_blank'
      );
    },
  });

  return pages;
};
